var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Moveable',{staticClass:"moveable",attrs:{"draggable":false,"resizable":false}},[_c('span',[_vm._v("Vue Moveable")]),_c('input',{attrs:{"type":"text","name":"","value":"textfield value"}})])}
var staticRenderFns = []

export { render, staticRenderFns }